import { Kind, URIS } from 'fp-ts/lib/HKT';
import { URI as ArrayURI } from 'fp-ts/lib/Array';
import * as O from 'fp-ts/lib/Option';
import { pipe } from 'fp-ts/lib/function';

export const is = <T extends Function>(T: T) => (thing: any): thing is T => thing instanceof T;

const URI = 'Id';
export type URI = typeof URI;

type Id<A> = A;

declare module 'fp-ts/lib/HKT' {
    interface URItoKind<A> {
        [URI]: Id<A>
    }
}

interface Nullable {
    'Array': never,
    'Id': null,
}

type KindN<F> = F extends keyof Nullable ? Nullable[F] : never;

type NonType<F extends URIS> = Kind<F, KindN<F>>


interface Applicative<F extends URIS> {
    of: <A>(a: A) => Kind<F, A>,
}

interface Add<F extends URIS> {
    append: <A>(a: A) => (m: Kind<F, A>) => Kind<F, A>,
}

interface RemoveLast<F extends URIS> {
    removeLast: <A>(m: Kind<F, A>) => Kind<F, A> | NonType<F>,
}

interface Take<F extends URIS> {
    take: <A>(m: Kind<F, A>) => O.Option<A>,
}

interface Clear<F extends URIS> {
    clear: <A>(m: Kind<F, A>) => NonType<F>,
}

export interface TableAlgebra<F extends URIS>  extends Applicative<F>, Add<F>, RemoveLast<F>, Take<F>, Clear<F> {}

export const idFTable: TableAlgebra<URI> = {
    of: (x) => x,
    append: (x) => () => x,
    removeLast: () => null,
    take: (m) => pipe(m, O.fromNullable),
    clear: () => null,
}

export const arrayFTable: TableAlgebra<ArrayURI> = {
    of: (x) => [x],
    append: (x) => (m) => [...m, x],
    removeLast: (m) => m.slice(0, -1),
    take: (m) => m.length === 0 ? O.none : O.some(m[m.length - 1]),
    clear: () => [],
}
